export enum ConsoleColors {
    'DEFAULT' = 'background: #white; color: black; font-weight: bold; border: 1px dashed black;',
    'HEADING' = 'background: #white; color: black; font-weight: bold; border: 1px dashed black;',
    'TODO' = 'background: #white; color: black; font-weight: bold; border: 1px dashed black;',
    'WARNING' = 'background: #white; color: black; font-weight: bold; border: 1px dashed black;',
    'TEMP' = 'background: #white; color: black; font-weight: bold; border: 1px dashed black;',
    'FORMULA' = 'background: #white; color: black; font-weight: bold; border: 1px dashed black;',
    'GIVEN' = 'background: #white; color: black; font-weight: bold; border: 1px dashed black;',
    'IFELSE_TRUE' = 'background: #white; color: black; font-weight: bold; border: 1px dashed black;',
    'IFELSE_FALSE' = 'background: #white; color: black; font-weight: bold; border: 1px dashed black;',
}

